import { render, staticRenderFns } from "./SponsoreOverDue.vue?vue&type=template&id=f20f41ee"
import script from "./SponsoreOverDue.vue?vue&type=script&lang=js"
export * from "./SponsoreOverDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports